import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";

const AddCoupon = () => {
  const [couponData, setCouponData] = useState({
    coupon_code: "",
    discount_amount: "",
    min_order_amount: "",
    valid_from: "",
    valid_to: "",
    description: "",
    usage_limit: "",
  });

  // jQuery Datepicker initialization
  useEffect(() => {
    $("#valid_from, #valid_to").datepicker({
      dateFormat: "yy-mm-dd",
      changeMonth: true,
      changeYear: true,
      onSelect: function (dateText, inst) {
        setCouponData((prevState) => ({
          ...prevState,
          [inst.id]: dateText,
        }));
      },
    });
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCouponData({
      ...couponData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate required fields
    if (
      !couponData.coupon_code.trim() ||
      !couponData.discount_amount.trim() ||
      !couponData.min_order_amount.trim() ||
      !couponData.valid_from.trim() ||
      !couponData.valid_to.trim()
    ) {
      Swal.fire("Validation Error", "All fields are required", "warning");
      return;
    }

    console.log("📤 Sending Coupon Data:", couponData);

    try {
      await axios.post(`${baseurl}addCoupon`, couponData);
      Swal.fire("Success", "Coupon added successfully!", "success").then(() => {
        setCouponData({
          coupon_code: "",
          discount_amount: "",
          min_order_amount: "",
          valid_from: "",
          valid_to: "",
          description: "",
          usage_limit: "",
        });
      });
    } catch (error) {
      console.error("❌ Error adding coupon:", error);
      Swal.fire("Error", "Failed to add coupon. Try again!", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <h4 className="mb-3 text-start">Add New Coupon</h4>

          {/* Coupon Form */}
          <div className="crd1 mb-3">
            <form onSubmit={handleSubmit}>
              <div className="row mb-3 text-start">
                {/* Coupon Code */}
                <div className="col-md-4">
                  <label className="form-label">Coupon Code</label>
                  <input
                    type="text"
                    name="coupon_code"
                    className="form-control"
                    placeholder="Enter Coupon Code"
                    value={couponData.coupon_code}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Discount Amount */}
                <div className="col-md-4">
                  <label className="form-label">Discount Amount</label>
                  <input
                    type="number"
                    name="discount_amount"
                    className="form-control"
                    placeholder="Enter Discount Amount"
                    value={couponData.discount_amount}
                    onChange={handleInputChange}
                  />
                </div>


                {/* Minimum Order Amount */}
                <div className="col-md-4">
                  <label className="form-label">Minimum Order Amount</label>
                  <input
                    type="number"
                    name="min_order_amount"
                    className="form-control"
                    placeholder="Minimum Order Amount"
                    value={couponData.min_order_amount}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Usage Limit */}
                <div className="col-md-4">
                  <label className="form-label">Usage Limit</label>
                  <input
                    type="number"
                    name="usage_limit"
                    className="form-control"
                    placeholder="Usage Limit"
                    value={couponData.usage_limit}
                    onChange={handleInputChange}
                  />
                </div>

{/* Valid From */}
<div className="col-md-4">
                  <label className="form-label">Valid From</label>
                  <input
                    type="text"
                    id="valid_from"
                    name="valid_from"
                    className="form-control"
                    placeholder="Select Start Date"
                    value={couponData.valid_from}
                    readOnly
                  />
                </div>

                {/* Valid To */}
                <div className="col-md-4">
                  <label className="form-label">Valid To</label>
                  <input
                    type="text"
                    id="valid_to"
                    name="valid_to"
                    className="form-control"
                    placeholder="Select End Date"
                    value={couponData.valid_to}
                    readOnly
                  />
                </div>

              </div>

           
                
               
 
                
             

              {/* Description */}
              <div className="row mb-3  text-start">
                <div className="col-md-12">
                  <label className="form-label">Coupon Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    rows="3"
                    placeholder="Enter Coupon Description"
                    value={couponData.description}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="text-start mt-3">
                <button type="submit" className="btn btn-primary">
                  Add Coupon
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCoupon;
